module.exports = __webpack_public_path__ + "static/textinput-helptext-dont-ada204ac16b5148c98d51b6997e19063.png";